import React, { useState, useEffect } from "react";
import "./App.css";

function App() {
  const [ttc, setTtc] = useState("");
  const [categories, setCategories] = useState({});
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [lastSelected, setLastSelected] = useState("");
  const [viewAll, setViewAll] = useState(false);

  useEffect(() => {
    fetch("/ttc.json")
      .then((response) => response.json())
      .then((data) => setCategories(data));
  }, []);

  const handleCategoryChange = (category) => {
    if (category === "ALL") {
      if (selectedCategories.length === Object.keys(categories).length) {
        setSelectedCategories([]); // Deselect all
      } else {
        setSelectedCategories(Object.keys(categories)); // Select all
      }
    } else {
      setSelectedCategories(
        (prev) =>
          prev.includes(category)
            ? prev.filter((c) => c !== category) // Remove if already selected
            : [...prev, category] // Add if not selected
      );
    }
  };

  const getRandomTTC = () => {
    let allPhrases = [];

    if (selectedCategories.length === 0) {
      Object.values(categories).forEach((category) => {
        allPhrases = allPhrases.concat(category);
      });
    } else {
      selectedCategories.forEach((category) => {
        allPhrases = allPhrases.concat(categories[category]);
      });
    }

    allPhrases = allPhrases.filter((phrase) => phrase !== lastSelected);

    if (allPhrases.length > 0) {
      const randomPhrase =
        allPhrases[Math.floor(Math.random() * allPhrases.length)];
      setTtc(randomPhrase);
      setLastSelected(randomPhrase);
    }
  };

  return (
    <div className="container">
      <h1 className="title">Thought-Terminating Cliché Generator</h1>

      <div className="checkbox-container">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={
              selectedCategories.length === Object.keys(categories).length
            }
            onChange={() => handleCategoryChange("ALL")}
          />
          ALL
        </label>

        {Object.keys(categories).map((category) => (
          <label key={category} className="checkbox-label">
            <input
              type="checkbox"
              checked={selectedCategories.includes(category)}
              onChange={() => handleCategoryChange(category)}
            />
            {category.replace(/_/g, " ")}
          </label>
        ))}
      </div>

      <button onClick={getRandomTTC} className="button">
        Generate Thought-Terminating Cliché
      </button>

      <button onClick={() => setViewAll(!viewAll)} className="button">
        {viewAll ? "Hide All Clichés" : "View All Clichés"}
      </button>

      {ttc && <p className="result">"{ttc}"</p>}

      {viewAll && (
        <div className="list-container">
          <h2 className="list-title">All Thought-Terminating Clichés</h2>
          {Object.entries(categories).map(([category, phrases]) => (
            <div key={category}>
              <h3 className="list-category">{category.replace(/_/g, " ")}</h3>
              <ul>
                {phrases.map((phrase, index) => (
                  <li key={index} className="list-item">
                    "{phrase}"
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default App;
